import React, { useEffect, useState } from "react";
import { Modal } from "@mantine/core";
import { toast } from "react-toastify";
import { formatUnixDateToThai } from "../../utils/common";
import { IoIosSwap } from "react-icons/io";
import moment from "moment";

interface HotSpotStatusPropType {
  onClose: (value: boolean) => void;
  open: boolean;
  features?: any;
  coordinate?: number[];
  hideStatusBar?: boolean;
}

function HotSpotStatus({
  open,
  onClose,
  features,
  hideStatusBar = false,
  coordinate,
}: HotSpotStatusPropType) {
  const [status, setStatus] = useState(1);
  const [positionType, setPositionType] = useState<"UTM" | "LatLong">("UTM");
  const [locationUTM, setLocationUTM] = useState({
    x: 0,
    y: 0,
    z: 0,
    zLetter: "P",
  });
  const handleClipboard = () => {
    if (positionType === "UTM") {
      navigator.clipboard.writeText(`${
        features?.properties.utm_zone ? features.properties.utm_zone : 0
      }
      ${
        features?.properties.v_direct ? features?.properties.v_direct : "N"
      }, ${features.properties.utm_e.toFixed(
        0
      )}E, ${features.properties.utm_n.toFixed(0)}N`);
    } else {
      if (coordinate && coordinate.length > 1) {
        navigator.clipboard.writeText(`${coordinate[0]} , ${coordinate[1]}`);
      } else {
        return;
      }
    }
    toast.success("คัดลอกสำเร็จ", {
      position: "bottom-left",
      autoClose: 3000,
    });
  };
  const handleConvertUTM = (coordinate: number[]) => {
    const utm = require("utm");
    let point = utm.fromLatLon(coordinate[1], coordinate[0]);
    let location = locationUTM;
    location.x = point.easting;
    location.y = point.northing;
    location.z = point.zoneNum;
    location.zLetter = point.zoneLetter;
    setLocationUTM(location);
  };
  const handleChangePositionType = () => {
    setPositionType(positionType === "UTM" ? "LatLong" : "UTM");
  };

  useEffect(() => {
    if (coordinate) {
      handleConvertUTM(coordinate);
    }
  }, [coordinate]);

  useEffect(() => {
    if (features) {
      if (features.properties["survey@status"]) {
        if (features.properties["survey@status"] === "draft") {
          setStatus(2);
        }
        if (features.properties["survey@status"] === "approved") {
          setStatus(3);
        }
      } else {
        setStatus(1);
      }
    }
  }, [features]);

  return (
    <Modal
      opened={open}
      onClose={() => onClose(false)}
      radius={32}
      padding={24}
      closeOnClickOutside={false}
      withCloseButton={false}
      centered
    >
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <div className="flex flex-col gap-2">
            <p className="text-text-primary text-base font-normal">
              สถานะจุดความร้อน
            </p>
          </div>
          <button onClick={() => onClose(false)}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_2133_80495)">
                <path
                  d="M12 23.9883C18.5647 23.9883 24 18.5439 24 11.9941C24 5.43264 18.5529 0 11.9882 0C5.43529 0 0 5.43264 0 11.9941C0 18.5439 5.44705 23.9883 12 23.9883ZM8.04705 16.9329C7.50587 16.9329 7.08235 16.4979 7.08235 15.957C7.08235 15.6982 7.17646 15.4512 7.3647 15.2748L10.6235 12.0059L7.3647 8.74866C7.17646 8.56053 7.08235 8.32534 7.08235 8.06665C7.08235 7.51397 7.50587 7.10242 8.04705 7.10242C8.31764 7.10242 8.5294 7.19648 8.71764 7.37288L12 10.6419L15.3059 7.36111C15.5059 7.16121 15.7177 7.0789 15.9764 7.0789C16.5176 7.0789 16.953 7.50222 16.953 8.04313C16.953 8.31359 16.8706 8.52525 16.6588 8.73691L13.3882 12.0059L16.6471 15.2632C16.8471 15.4396 16.9412 15.6864 16.9412 15.957C16.9412 16.4979 16.5059 16.9329 15.9529 16.9329C15.6824 16.9329 15.4353 16.8389 15.2588 16.6507L12 13.3817L8.75292 16.6507C8.5647 16.8389 8.31764 16.9329 8.04705 16.9329Z"
                  fill="#B0B0B0"
                />
              </g>
              <defs>
                <clipPath id="clip0_2133_80495">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
        {!hideStatusBar && (
          <div className="flex flex-col gap-1 relative">
            <div
              className={`bg-primary-main ${
                status === 1 ? "block" : "hidden"
              } bg-opacity-20 rounded-full w-8 h-8 absolute -top-1 left-[37px] -z-10`}
            />
            <div
              className={`bg-primary-main ${
                status === 2 ? "block" : "hidden"
              } bg-opacity-20 rounded-full w-8 h-8 absolute -top-1 left-[180px] -z-10`}
            />

            <div
              className={`bg-primary-main ${
                status === 3 ? "block" : "hidden"
              } bg-opacity-20 rounded-full w-8 h-8 absolute -top-1 left-[323px] -z-10`}
            />
            <div className="flex items-center self-center">
              <div
                className={`w-6 h-6 rounded-full ${
                  status > 0 ? "bg-primary-main" : "bg-gray-2"
                } text-center py-[2px]`}
              >
                <p className="text-primary-contrast text-sm font-normal">1</p>
              </div>
              <div
                className={`w-[119px] h-[2px] ${
                  status > 1 ? "bg-primary-main" : "bg-gray-2"
                }`}
              />
              <div
                className={`w-6 h-6 rounded-full  ${
                  status > 1 ? "bg-primary-main" : "bg-gray-2"
                } text-center py-[2px]`}
              >
                <p className="text-primary-contrast text-sm font-normal">2</p>
              </div>
              <div
                className={`w-[119px] h-[2px] ${
                  status > 2 ? "bg-primary-main" : "bg-gray-2"
                }`}
              />
              <div
                className={`w-6 h-6 rounded-full ${
                  status > 2 ? "bg-primary-main" : "bg-gray-2"
                } text-center py-[2px]`}
              >
                <p className="text-primary-contrast text-sm font-normal">3</p>
              </div>
            </div>
            <div className="flex self-center justify-around gap-[88px]">
              <p
                className={`text-xs font-normal  ${
                  status === 1 ? "text-primary-main" : "text-text-secondary"
                }`}
              >
                รับทราบ
              </p>
              <p
                className={`text-xs font-normal  ${
                  status === 2 ? "text-primary-main" : "text-text-secondary"
                }`}
              >
                กำลังดำเนินการ
              </p>
              <p
                className={`text-xs font-normal  ${
                  status === 3 ? "text-primary-main" : "text-text-secondary"
                }`}
              >
                ดับไฟแล้ว
              </p>
            </div>
          </div>
        )}
        <div className="w-full flex flex-col gap-2">
          <div className="flex justify-between ">
            <div className="flex gap-2">
              <div className="shrink-0">
                <svg
                  width="22"
                  height="24"
                  viewBox="0 0 22 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.0008 13.592C11.8492 13.592 12.6629 13.2551 13.263 12.6553C13.863 12.0555 14.2004 11.242 14.2008 10.3936C14.2008 9.54491 13.8636 8.73098 13.2635 8.13086C12.6634 7.53075 11.8495 7.1936 11.0008 7.1936C10.1521 7.1936 9.33816 7.53075 8.73804 8.13086C8.13792 8.73098 7.80078 9.54491 7.80078 10.3936C7.80121 11.242 8.13853 12.0555 8.7386 12.6553C9.33868 13.2551 10.1524 13.592 11.0008 13.592Z"
                    stroke="#C44A25"
                    strokeLinecap="square"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.6004 10.3936C20.6004 18.3888 12.6004 23.1856 11.0004 23.1856C9.40039 23.1856 1.40039 18.3888 1.40039 10.3936C1.40166 7.84855 2.4137 5.40815 4.21396 3.60909C6.01422 1.81004 8.45529 0.799624 11.0004 0.800049C16.3012 0.800049 20.6004 5.09605 20.6004 10.3936Z"
                    stroke="#C44A25"
                    strokeLinecap="square"
                  />
                </svg>
              </div>
              {positionType === "UTM" ? (
                <p className="w-full text-text-primary font-light text-sm">
                  พิกัด{" "}
                  {features?.properties.utm_zone
                    ? features.properties.utm_zone
                    : 0}
                  {features?.properties.v_direct
                    ? features?.properties.v_direct
                    : "N"}
                  ,{features?.properties.utm_e.toFixed(0)}E,
                  {features?.properties.utm_n.toFixed(0)}N
                </p>
              ) : (
                <>
                  {coordinate && coordinate?.length > 1 ? (
                    <p className="w-full text-text-primary font-light text-sm truncate max-w-[250px]">
                      พิกัด {coordinate[0]} , {coordinate[1]}
                    </p>
                  ) : (
                    <p className="w-full text-text-primary font-light text-sm">
                      -
                    </p>
                  )}
                </>
              )}
            </div>
            <div className="flex gap-2">
              <button onClick={handleChangePositionType}>
                <IoIosSwap size={24} color={"#8E8E8E"} />
              </button>
              <button onClick={() => handleClipboard()}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 1.25H10.944C9.106 1.25 7.65 1.25 6.511 1.403C5.339 1.561 4.39 1.893 3.641 2.641C2.893 3.39 2.561 4.339 2.403 5.511C2.25 6.651 2.25 8.106 2.25 9.944V16C2.25002 16.8934 2.56894 17.7575 3.14934 18.4367C3.72974 19.1159 4.53351 19.5657 5.416 19.705C5.553 20.469 5.818 21.121 6.348 21.652C6.95 22.254 7.708 22.512 8.608 22.634C9.475 22.75 10.578 22.75 11.945 22.75H15.055C16.422 22.75 17.525 22.75 18.392 22.634C19.292 22.512 20.05 22.254 20.652 21.652C21.254 21.05 21.512 20.292 21.634 19.392C21.75 18.525 21.75 17.422 21.75 16.055V10.945C21.75 9.578 21.75 8.475 21.634 7.608C21.512 6.708 21.254 5.95 20.652 5.348C20.121 4.818 19.469 4.553 18.705 4.416C18.5657 3.53351 18.1159 2.72974 17.4367 2.14934C16.7575 1.56894 15.8934 1.25002 15 1.25ZM17.13 4.271C16.9779 3.827 16.6909 3.44166 16.3089 3.16893C15.927 2.89619 15.4693 2.74971 15 2.75H11C9.093 2.75 7.739 2.752 6.71 2.89C5.705 3.025 5.125 3.279 4.702 3.702C4.279 4.125 4.025 4.705 3.89 5.711C3.752 6.739 3.75 8.093 3.75 10V16C3.74971 16.4693 3.89619 16.927 4.16892 17.3089C4.44166 17.6908 4.827 17.9779 5.271 18.13C5.25 17.52 5.25 16.83 5.25 16.055V10.945C5.25 9.578 5.25 8.475 5.367 7.608C5.487 6.708 5.747 5.95 6.348 5.348C6.95 4.746 7.708 4.488 8.608 4.367C9.475 4.25 10.578 4.25 11.945 4.25H15.055C15.83 4.25 16.52 4.25 17.13 4.271ZM7.408 6.41C7.685 6.133 8.073 5.953 8.808 5.854C9.562 5.753 10.564 5.751 11.999 5.751H14.999C16.434 5.751 17.435 5.753 18.191 5.854C18.925 5.953 19.313 6.134 19.59 6.41C19.867 6.687 20.047 7.075 20.146 7.81C20.247 8.564 20.249 9.566 20.249 11.001V16.001C20.249 17.436 20.247 18.437 20.146 19.193C20.047 19.927 19.866 20.315 19.59 20.592C19.313 20.869 18.925 21.049 18.19 21.148C17.435 21.249 16.434 21.251 14.999 21.251H11.999C10.564 21.251 9.562 21.249 8.807 21.148C8.073 21.049 7.685 20.868 7.408 20.592C7.131 20.315 6.951 19.927 6.852 19.192C6.751 18.437 6.749 17.436 6.749 16.001V11.001C6.749 9.566 6.751 8.564 6.852 7.809C6.951 7.075 7.132 6.687 7.408 6.41Z"
                    fill="#8E8E8E"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="flex gap-2 ">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.6941 18.1562L16.1975 11.661L16.7997 11.0588C16.9448 10.9143 17.0363 10.7246 17.0589 10.5211C17.0815 10.3176 17.0339 10.1125 16.924 9.93976L17.2521 9.61182C17.3411 9.5246 17.4104 9.41949 17.4557 9.30345C17.5009 9.18741 17.521 9.06308 17.5146 8.9387C18.1817 9.15792 18.8965 9.18749 19.5794 9.0241C20.2622 8.86071 20.8863 8.51079 21.3818 8.01338C21.4123 7.98294 21.4365 7.94679 21.453 7.90699C21.4695 7.86719 21.478 7.82453 21.478 7.78145C21.478 7.73836 21.4695 7.6957 21.453 7.6559C21.4365 7.6161 21.4123 7.57995 21.3818 7.54951L19.148 5.31563L19.8471 4.61645C20.0627 4.73815 20.3123 4.78572 20.5575 4.75185C20.8028 4.71798 21.0301 4.60453 21.2046 4.42895C21.3549 4.28022 21.461 4.09271 21.511 3.88727C21.561 3.68184 21.553 3.46656 21.4879 3.2654C21.4229 3.06423 21.3032 2.88508 21.1423 2.74789C20.9814 2.6107 20.7856 2.52086 20.5767 2.48837C20.3678 2.45587 20.154 2.482 19.959 2.56385C19.7641 2.6457 19.5957 2.78005 19.4725 2.95194C19.3494 3.12383 19.2764 3.32652 19.2617 3.53744C19.247 3.74836 19.2911 3.95923 19.3891 4.14657L18.6841 4.85176L16.4688 2.63645C16.4072 2.57495 16.3238 2.54041 16.2367 2.54041C16.1497 2.54041 16.0663 2.57495 16.0047 2.63645C15.5112 3.13117 15.1635 3.75229 14.9998 4.43164C14.8361 5.11099 14.8627 5.8223 15.0768 6.48751C14.9501 6.47834 14.823 6.49685 14.7042 6.54176C14.5855 6.58667 14.4779 6.6569 14.389 6.74757L14.0601 7.07645C13.887 6.96752 13.6821 6.92051 13.4788 6.94309C13.2756 6.96567 13.0859 7.0565 12.941 7.20076L12.3387 7.8032L5.8437 1.30557C5.75985 1.22155 5.66024 1.1549 5.5506 1.10942C5.44095 1.06394 5.32341 1.04053 5.2047 1.04053C5.086 1.04053 4.96846 1.06394 4.85881 1.10942C4.74916 1.1549 4.64956 1.22155 4.5657 1.30557L1.30527 4.56601C1.13605 4.73558 1.04102 4.96536 1.04102 5.20491C1.04102 5.44447 1.13605 5.67425 1.30527 5.84382L7.80195 12.339L7.1997 12.9413C7.07119 13.0692 6.98438 13.233 6.95068 13.4112C6.91698 13.5894 6.93797 13.7737 7.01089 13.9397C6.61759 14.337 6.39745 14.8737 6.39854 15.4327C6.39963 15.9918 6.62186 16.5276 7.0167 16.9234L7.07652 16.9832C7.47184 17.3791 8.00812 17.602 8.56763 17.6029C9.12714 17.6039 9.66415 17.3827 10.0608 16.9881C10.2266 17.0609 10.4105 17.082 10.5885 17.0486C10.7665 17.0151 10.9302 16.9287 11.0583 16.8006L11.6607 16.1981L18.1557 22.695C18.2396 22.779 18.3391 22.8456 18.4488 22.8911C18.5584 22.9366 18.6759 22.96 18.7946 22.96C18.9133 22.96 19.0308 22.9366 19.1404 22.8911C19.2501 22.8456 19.3497 22.779 19.4335 22.695L22.6941 19.4346C22.8635 19.265 22.9587 19.0351 22.9587 18.7954C22.9587 18.5557 22.8635 18.3258 22.6941 18.1562ZM20.0534 3.27751C20.1214 3.20955 20.208 3.16327 20.3022 3.14453C20.3965 3.12578 20.4942 3.13541 20.583 3.1722C20.6718 3.20899 20.7477 3.27128 20.8011 3.3512C20.8545 3.43112 20.883 3.52508 20.883 3.6212C20.883 3.71731 20.8545 3.81127 20.8011 3.89119C20.7477 3.97111 20.6718 4.03341 20.583 4.07019C20.4942 4.10698 20.3965 4.11661 20.3022 4.09786C20.208 4.07912 20.1214 4.03284 20.0534 3.96488C19.9626 3.87354 19.9116 3.74999 19.9116 3.6212C19.9116 3.49241 19.9626 3.36885 20.0534 3.27751ZM20.0138 16.4044L18.4411 17.9773L16.5141 16.05L18.0867 14.4774L20.0138 16.4044ZM17.6226 14.0139L16.0497 15.5865L14.161 13.6973L15.7332 12.1251L17.6226 14.0139ZM16.2486 3.3452L20.6736 7.7702C20.0694 8.2593 19.3055 8.50738 18.5292 8.46662C17.7528 8.42585 17.0191 8.09913 16.4694 7.54943C15.9197 6.99974 15.593 6.266 15.5522 5.48968C15.5115 4.71336 15.7595 3.94944 16.2486 3.3452ZM14.8542 7.20976C14.9008 7.16487 14.963 7.13988 15.0277 7.14009C15.0924 7.1403 15.1544 7.16569 15.2007 7.21088L16.79 8.79995C16.8129 8.82262 16.8311 8.84962 16.8436 8.8794C16.856 8.90917 16.8624 8.94112 16.8624 8.97338C16.8624 9.00565 16.856 9.0376 16.8436 9.06737C16.8311 9.09714 16.8129 9.12415 16.79 9.14682L16.478 9.45863L14.5411 7.5227L14.8542 7.20976ZM11.8746 8.26651L10.3025 9.8387L8.4132 7.95001L9.98577 6.37745L11.8746 8.26651ZM9.52189 5.91301L7.9497 7.48557L6.02239 5.55863L7.59514 3.98588L9.52189 5.91301ZM5.02977 1.76963C5.07679 1.72452 5.13944 1.69933 5.20461 1.69933C5.26978 1.69933 5.33243 1.72452 5.37945 1.76963L7.13127 3.52182L5.55833 5.09457L3.63158 3.16876L5.02977 1.76963ZM1.76914 5.37995C1.72287 5.33352 1.69689 5.27065 1.69689 5.2051C1.69689 5.13956 1.72287 5.07668 1.76914 5.03026L3.16845 3.6317L5.09445 5.55863L3.52152 7.13157L1.76914 5.37995ZM3.98558 7.59563L5.55833 6.0227L7.48527 7.95001L5.9127 9.52257L3.98558 7.59563ZM6.37677 9.98607L7.9497 8.41351L9.83839 10.3028L8.26602 11.8749L6.37677 9.98607ZM7.54039 16.5188L7.48039 16.4589C7.21657 16.1941 7.06448 15.8381 7.05551 15.4644C7.04654 15.0907 7.18138 14.7278 7.4322 14.4506L9.5487 16.5677C9.27197 16.8195 8.9088 16.955 8.53474 16.9459C8.16068 16.9368 7.80453 16.7838 7.54039 16.5188ZM10.5944 16.3354C10.5486 16.381 10.4867 16.4068 10.422 16.4073C10.3574 16.4077 10.2951 16.3828 10.2486 16.3378C10.2462 16.3352 10.2432 16.3337 10.2408 16.3313L7.66845 13.7593C7.6662 13.7569 7.6647 13.7541 7.66227 13.7518C7.61697 13.7055 7.59181 13.6432 7.59227 13.5784C7.59273 13.5137 7.61876 13.4517 7.6647 13.4061L13.406 7.66426C13.4523 7.61797 13.5151 7.59196 13.5806 7.59196C13.6461 7.59196 13.7089 7.61797 13.7553 7.66426L16.3356 10.2454C16.3586 10.2683 16.3768 10.2955 16.3892 10.3255C16.4016 10.3555 16.408 10.3876 16.408 10.42C16.408 10.4525 16.4016 10.4846 16.3892 10.5146C16.3768 10.5445 16.3586 10.5718 16.3356 10.5947L10.5944 16.3354ZM12.1248 15.7331L13.697 14.1609L15.5862 16.05L14.0136 17.6226L12.1248 15.7331ZM14.4775 18.087L16.0497 16.5144L17.977 18.4414L16.4043 20.0141L14.4775 18.087ZM18.9696 22.2308C18.9226 22.2759 18.86 22.3011 18.7948 22.3011C18.7296 22.3011 18.667 22.2759 18.62 22.2308L16.8681 20.4784L18.4411 18.9056L20.3678 20.8324L18.9696 22.2308ZM22.2301 18.9701L20.8319 20.3685L18.905 18.4414L20.4779 16.8684L22.2301 18.6201C22.2764 18.6665 22.3025 18.7294 22.3025 18.795C22.3025 18.8606 22.2764 18.9235 22.2301 18.9699V18.9701Z"
                fill="#C44A25"
              />
            </svg>

            <p className="w-full text-text-primary font-light text-sm">
              ดาวเทียม {features?.properties?.satellite}
            </p>
          </div>
          <div className="flex gap-2 ">
            <svg
              width="24"
              height="20"
              viewBox="0 0 24 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.4209 6.06486L5.94619 7.50275L5.94616 7.5028L5.94837 7.50391C6.02726 7.54382 6.11833 7.55146 6.20268 7.5252C6.28701 7.49896 6.35796 7.44091 6.40105 7.3633C6.44412 7.28571 6.45612 7.19438 6.43464 7.10815C6.41317 7.0219 6.35979 6.94713 6.28531 6.89944L6.28535 6.89938L6.28308 6.89809L3.37829 5.24472C3.37822 5.24468 3.37816 5.24464 3.3781 5.24461C3.33301 5.21846 3.28258 5.20309 3.23066 5.19973C3.17868 5.19636 3.12664 5.20511 3.07854 5.2253C3.03046 5.24548 2.98763 5.27654 2.95332 5.31604L2.99067 5.34848L2.95332 5.31604C2.91907 5.35547 2.89421 5.40226 2.88057 5.45282C2.88055 5.45291 2.88052 5.45301 2.8805 5.4531L-0.0367875 15.8431C-0.0367901 15.8431 -0.0367928 15.8431 -0.0367954 15.8431L-0.0368164 15.8432L0.011322 15.8567M3.4209 6.06486L18.3479 19.5374L11.9996 17.7801L5.65133 19.5374C5.65129 19.5374 5.65124 19.5374 5.6512 19.5375C5.62172 19.5457 5.59128 19.5499 5.56069 19.55L5.55891 19.55L5.55891 19.5499C5.50527 19.5481 5.45282 19.5338 5.40562 19.5082C5.40383 19.5079 5.40161 19.5074 5.39932 19.5068C5.39444 19.5055 5.38784 19.5032 5.38095 19.4988L0.113863 16.2335C0.113833 16.2335 0.113803 16.2335 0.113773 16.2335L0.113758 16.2335L0.140103 16.191C0.085467 16.1573 0.0432642 16.1063 0.0199938 16.0459C-0.00327646 15.9855 -0.0063235 15.919 0.011322 15.8567M3.4209 6.06486L0.693041 15.7788L5.28637 18.626L6.39077 9.66016C6.39633 9.61502 6.4106 9.57141 6.43279 9.53181C6.45499 9.49221 6.48468 9.45738 6.52021 9.42934C6.55574 9.4013 6.59641 9.38061 6.6399 9.36847C6.68339 9.35634 6.72883 9.35301 6.77361 9.35868C6.81838 9.36435 6.86159 9.37891 6.90076 9.40149C6.93993 9.42408 6.97428 9.45424 7.00188 9.49023C7.02947 9.52621 7.04979 9.56731 7.06169 9.61119C7.07359 9.65506 7.07685 9.70086 7.07129 9.746L5.96415 18.7318L11.6569 17.1558V15.5729C11.6569 15.4811 11.6929 15.393 11.7571 15.3279C11.8213 15.2627 11.9085 15.226 11.9996 15.226C12.0907 15.226 12.178 15.2627 12.2422 15.3279C12.3064 15.393 12.3423 15.4811 12.3423 15.5729V17.1558L18.0345 18.7318L16.9274 9.746C16.9161 9.65488 16.941 9.56288 16.9968 9.49023C17.0525 9.41755 17.1346 9.37013 17.225 9.35868C17.3155 9.34722 17.4067 9.3727 17.4784 9.42934C17.5502 9.48596 17.5967 9.56903 17.6079 9.66015L18.7129 18.626L23.3062 15.7782L20.5783 6.06368L18.053 7.50156L18.0509 7.50278L18.0509 7.50273C17.972 7.54263 17.8809 7.55027 17.7966 7.52402C17.7122 7.49777 17.6413 7.43972 17.5982 7.36211C17.5551 7.28452 17.5431 7.19319 17.5646 7.10696C17.5861 7.02072 17.6394 6.94595 17.7139 6.89825L17.7161 6.89684L17.7162 6.8969L20.6206 5.24398L20.6207 5.2439V5.2439C20.6659 5.21804 20.7163 5.20291 20.7682 5.19969C20.8201 5.19646 20.872 5.20525 20.92 5.22538C20.968 5.2455 21.0109 5.27642 21.0452 5.31572C21.0796 5.35499 21.1047 5.40162 21.1186 5.45206C21.1186 5.4521 21.1186 5.45214 21.1186 5.45219L24.036 15.8426L24.0361 15.8427C24.0563 15.9154 24.0526 15.9928 24.0255 16.0631C23.9984 16.1335 23.9493 16.1931 23.8856 16.2328L23.8855 16.2329L18.6177 19.4982C18.6074 19.5048 18.5972 19.507 18.5926 19.5079M3.4209 6.06486L18.5926 19.5079M0.011322 15.8567L2.92879 5.46608L0.011322 15.8567ZM18.5926 19.5079C18.5459 19.5339 18.4936 19.5483 18.4402 19.5499L18.4385 19.55C18.408 19.5499 18.3775 19.5457 18.348 19.5375L18.5926 19.5079Z"
                fill="#C44A25"
                stroke="#C44A25"
                strokeWidth="0.1"
              />
              <path
                d="M11.8006 14.3748C11.8543 14.4251 11.9247 14.4531 11.9978 14.4535C12.071 14.4538 12.1416 14.4264 12.1957 14.3765C12.3907 14.1966 16.9747 9.92994 16.9747 5.54688C16.9747 2.71647 14.7895 0.5 11.999 0.5C9.20861 0.5 7.02344 2.71647 7.02344 5.54688C7.02344 9.85394 11.6057 14.1919 11.8006 14.3748ZM11.999 1.09375C14.5015 1.09375 16.3893 3.008 16.3893 5.54688C16.3893 9.16697 12.8812 12.872 12.0008 13.7448C11.1222 12.8619 7.6088 9.10819 7.6088 5.54688C7.6088 3.008 9.49661 1.09375 11.999 1.09375Z"
                fill="#C44A25"
              />
              <path
                d="M14.6585 5.54688C14.6585 4.06031 13.4658 2.85 11.9994 2.85C10.5329 2.85 9.34023 4.06031 9.34023 5.54688C9.34023 7.03344 10.5329 8.24375 11.9994 8.24375C13.4658 8.24375 14.6585 7.03344 14.6585 5.54688ZM11.9994 7.6C10.8838 7.6 9.9756 6.67934 9.9756 5.54688C9.9756 4.41441 10.8838 3.49375 11.9994 3.49375C13.115 3.49375 14.0232 4.41441 14.0232 5.54688C14.0232 6.67934 13.115 7.6 11.9994 7.6Z"
                fill="#C44A25"
                stroke="#C44A25"
                strokeWidth="0.05"
              />
            </svg>

            {features?.properties?.ct_en === "Thailand" ? (
              <p className="w-full text-text-primary font-light text-sm">
                ต.{features?.properties?.tb_tn} อ.
                {features?.properties?.ap_tn} จ.
                {features?.properties?.pv_tn}
              </p>
            ) : (
              <p className="w-full text-text-primary font-light text-sm">
                {features?.properties?.ct_en}
              </p>
            )}
          </div>
          <div className="flex gap-2 ">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="1"
                y="2.5"
                width="18"
                height="18"
                rx="5"
                stroke="#C44A25"
              />
              <path d="M1 7.5H19" stroke="#C44A25" strokeLinejoin="round" />
              <path
                d="M14.5 1L14.5 4"
                stroke="#C44A25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5.5 1L5.5 4"
                stroke="#C44A25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.5 11.5H5.5"
                stroke="#C44A25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.5 11.5H10.5"
                stroke="#C44A25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.5 11.5H15.5"
                stroke="#C44A25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.5 15.5H5.5"
                stroke="#C44A25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.5 15.5H10.5"
                stroke="#C44A25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.5 15.5H15.5"
                stroke="#C44A25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <p className="w-full text-text-primary font-light text-sm">
              {`วันที่ดาวเทียมพบจุด 
              ${formatUnixDateToThai(features?.properties?.timestamp)}`}
            </p>
          </div>
          <div className="flex gap-2 ">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 3C7.03125 3 3 7.03125 3 12C3 16.9688 7.03125 21 12 21C16.9688 21 21 16.9688 21 12C21 7.03125 16.9688 3 12 3Z"
                stroke="#C44A25"
                strokeMiterlimit="10"
              />
              <path
                d="M12 6V12.75H16.5"
                stroke="#C44A25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="w-full text-text-primary font-light text-sm">
              เวลาที่ดาวเทียมพบจุด{" "}
              {moment(
                new Date(
                  features?.properties.timestamp * 1000 - 7 * 60 * 60 * 1000
                )
              ).format("HH:mm")}
            </p>
          </div>
          <div className="py-2 w-fit px-2 rounded-[32px] bg-primary-light">
            <p className="text-xs font-light text-primary-main">
              {features?.properties?.lu_code === 0
                ? "จุดความร้อนนอกประเทศ"
                : features?.properties?.lu_name}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default HotSpotStatus;
